export default __webpack_public_path__ + "static/media/smile.f6fe8121.jpg";